import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchSaveProjectRoleModifications = async (
  projectId,
  projectRoleModifications,
  projectAssignedDefaultRoleModifications,
  isCopyChangesToChildProjectRolesActive
) => {
  const apiPath = `permission/project/${projectId}/roles/update-project-roles`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {
      projectRoleModifications,
      projectAssignedDefaultRoleModifications,
      isCopyChangesToChildProjectRolesActive,
    },
  });
  const response = await axios(signedRequest);

  return response.data;
};
